import { LatestReleaseNoteI } from 'declarations/interfaces/releaseNotes';
import { useFetchLatestReleaseNote } from 'hooks/api/useReleaseNotes';

type useReleaseNotePopupT = {
  latestReleaseNote: LatestReleaseNoteI | null;
  isLoadingLatestReleaseNote: boolean;
};

const useReleaseNotePopup = (): useReleaseNotePopupT => {
  const releaseNotesResult = useFetchLatestReleaseNote();

  return {
    latestReleaseNote: releaseNotesResult.data ?? null,
    isLoadingLatestReleaseNote: releaseNotesResult.isLoading || releaseNotesResult.isRefetching,
  };
};

export default useReleaseNotePopup;
